module.exports = __webpack_public_path__ + "static/media/Cadiz.9c1ead5c.jpg";